export default {
  list: [],
  error: null,
  loading: false,
  current: 'distribution_and_change'
};
